/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.navbar-default[_ngcontent-%COMP%]{background-color:#34495e;box-shadow:0 2px 5px 0 rgba(0,0,0,.2);margin-bottom:0;height:50px;width:100%;border-radius:0;border:0;padding-right:15px;padding-left:15px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9tdWx0aS1lZGl0b3ItdG9vbGJhci9tdWx0aS1lZGl0b3ItdG9vbGJhci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9tdWx0aS1lZGl0b3IvbXVsdGktZWRpdG9yLXRvb2xiYXIvbXVsdGktZWRpdG9yLXRvb2xiYXIuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/multi-editor-toolbar/multi-editor-toolbar.component.scss.shim.ngstyle.ts